export const gwsAuditLogKey = {
  all: ['accesses', 'audit-log', 'gws'] as const,
  activeIntegrations: () => [...gwsAuditLogKey.all, 'active-integrations'] as const,
  config: (appIntegrationId: string) => [...gwsAuditLogKey.all, 'config', appIntegrationId] as const
} as const;